import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaBell, FaTimes } from "react-icons/fa";
import avatar from "../../assests/icons/profile.png";
import logo from "../../assests/images/tennismate-logo.webp";
import "./header.css";
// import { useNotification } from "./notificationContext";
// import { saveAuthData, saveUserData } from "../../store/slice/loginSlice";
import { logout } from "../../store/rootReducer";
import LogoutConfirmationModal from "./logoutConfirmationModal";
import StoreRoom from "../../store/store";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const {
  //   notifications,
  //   hasUnreadNotifications,
  //   markNotificationsAsRead,
  //   setNotifications,
  // } = useNotification();
  // const [showNotifications, setShowNotifications] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  // const notificationRef = useRef(null);

  // const handleBellClick = () => {
  //   markNotificationsAsRead();
  //   setShowNotifications((prev) => !prev);
  // };

  // const handleClearAll = () => {
  //   setNotifications([]);
  //   setShowNotifications(false);
  // };

  // const handleClose = (event) => {
  //   event.stopPropagation();
  //   setShowNotifications(false);
  // };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       notificationRef.current &&
  //       !notificationRef.current.contains(event.target)
  //     ) {
  //       setShowNotifications(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [notificationRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".position-relative")) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    StoreRoom.persistor.purge().then(() => {
      StoreRoom.persistor.flush();
      localStorage.removeItem("persist:itengo");
      sessionStorage.removeItem("persist:itengo");
      navigate("/login");
    });
  };

  return (
    <>
      <header className="header">
        <div className="profile-section">
          <img src={logo} alt="iTengo Logo" style={{ height: "50px" }} />
        </div>
        <div className="position-relative d-flex gap-3">
          <div
            className="notification-section"
            onClick={() => navigate("notifications")}
            // onClick={handleBellClick}
            // title={
            //   notifications.length === 0
            //     ? "No notifications"
            //     : "Click to view notifications"
            // }
          >
            {/* <div
            className={`notification-icon ${
              hasUnreadNotifications ? "glow" : ""
            }`}
          > */}
            <div className={`notification-icon`}>
              <FaBell />
            </div>
            {/* {showNotifications && (
            <div className="notification-box" ref={notificationRef}>
              <div className="notification-header">
                <span>Notifications</span>
                <FaTimes onClick={handleClose} className="close-icon" />
              </div>
              <div className="notification-body">
                {notifications.length === 0 ? (
                  <div className="no-notifications">
                    No notifications available.
                  </div>
                ) : (
                  notifications.map((note, index) => (
                    <div key={index} className="notification-item">
                      {note}
                    </div>
                  ))
                )}
              </div>
              {notifications.length > 0 && (
                <button className="clear-all-btn" onClick={handleClearAll}>
                  Clear All Notifications
                </button>
              )}
            </div>
          )} */}
          </div>
          <img src={avatar} alt="Profile" className="profile-avatar" onClick={() => setIsMenuOpen(!isMenuOpen)} />
          {isMenuOpen && (
            <ul className="dropdown-menu show">
              <li>
                <a className="dropdown-item" onClick={() => navigate("profile")}>
                  Profile
                </a>
              </li>
              <li>
                <a className="dropdown-item" onClick={() => setIsLogoutModalOpen(true)}>
                  Log Out
                </a>
              </li>
            </ul>
          )}
        </div>
      </header>
      <LogoutConfirmationModal
        isLogoutModalOpen={isLogoutModalOpen}
        closeLogoutModal={() => setIsLogoutModalOpen(false)}
        logout={handleLogout}
      />
    </>
  );
};

export default Header;
